module.exports = __webpack_public_path__ + "static/media/GHS06.4c1ad5aa.png";